module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('auction.auctionPhotos')))]), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('auction.photoFileExample')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$t('auction.photoFilenameExample')))])]), _vm._v(" "), _c('form', {
    staticClass: "mb-4",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [(_vm.mediaErrors.length > 0) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.mediaErrors), function(error) {
    return _c('span', [_vm._v("\n\t\t\t\t  \t\t\t\t" + _vm._s(error)), _c('br')])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dropbox",
    class: {
      hovered: _vm.hoverDropbox
    }
  }, [(_vm.isUploading == false) ? _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "dragenter": _vm.dragEnter,
      "dragleave": _vm.dragLeave,
      "drop": _vm.dragLeave,
      "change": function($event) {
        _vm.filesChange($event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadingFileCount < 1) ? _c('div', {
    staticClass: "dropbox-info"
  }, [_vm._v("\n\t\t\t\t\t\t\tPlaats uw bestanden hier om te beginnen\n\t\t\t\t\t\t\t"), _c('br'), _vm._v(" of klik om te selecteren\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.uploadingFileCount > 0) ? _c('div', {
    staticClass: "row dropbox-info justify-content-center"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('b-progress', {
    staticClass: "mb-2",
    attrs: {
      "value": _vm.uploadingStatus,
      "variant": "info",
      "striped": "",
      "animated": "",
      "height": "2rem"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.fileCount - _vm.uploadingFileCount) + " van " + _vm._s(_vm.fileCount) + " bestanden aan het uploaden...\n\t\t\t\t\t\t\t")], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "row media"
  }, _vm._l((_vm.mediaItems), function(media, index) {
    return _c('div', {
      staticClass: "col col-xl-1 col-lg-2 col-md-3 col-sm-4 media-item"
    }, [_c('figure', {
      staticClass: "media-item-image",
      style: ({
        backgroundImage: 'url(' + _vm.small(media.url) + ')'
      })
    })])
  }), 0)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af67283a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Photos.vue
// module id = 1336
// module chunks = 1